import { FC, PropsWithChildren } from 'react';

import { dom } from 'app/utils';
import { FloatLabel as Component } from '../external';
import { IComponent } from '../types';

export interface ILabel extends PropsWithChildren<IComponent> {
  text?: string;
  align?: 'start' | 'center' | 'end';
  asterisk?: boolean;
  weight?: string;

  floating?: boolean;
}

export const Field: FC<ILabel> = ({ id, className, style, text, align, asterisk, weight, floating, children }) => {
  const label: any = { id, style,
    className: dom.className('i-component', 'i-field', { 'i-floating': floating }, className),
  };

  const suffix = (asterisk ? <span className={dom.className('ml-2', 'text-lg', 'font-bold', 'text-red-400', { 'pt-1 pr-2 absolute top-0 right-0': !floating })}>*</span> : undefined);

  if (floating) return (
    <Component { ...label }>
      { children }
      <label className="i-title">
        { text }
        { suffix }
      </label>
    </Component>
  );

  const title: any = {
    className: dom.className('i-title', 'pr-3', 'flex', 'flex-none', 'align-items-center', 'relative', `justify-content-${align ?? 'start'}`, { 'text-right': (align === 'end') }),
    style: { width: (weight ?? '25%'), maxHeight: '3rem' },
  };
  const body: any = {
    className: dom.className('i-body', 'flex', 'flex-auto', 'align-items-center', 'justify-content-start'),
    style: { width: (weight ? `calc(100% - ${weight})` : '75%') },
  };

  return (
    <div { ...label }>
      <span { ...title }>
        { text }
        { suffix }
      </span>
      <span { ...body }>
        { children }
      </span>
    </div>
  );
}
